<template>
    <svg
        width="720"
        height="406"
        viewBox="0 0 720 406"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M720 334H0V406H720V334Z" fill="var(--et-colors-background)" />
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            font-weight="600"
            letter-spacing="0em"
        >
            <tspan x="24" y="365.3">Cookies consent</tspan>
        </text>
        <path
            d="M287 375.5H30C26.6863 375.5 24 378.186 24 381.5C24 384.814 26.6863 387.5 30 387.5H287C290.314 387.5 293 384.814 293 381.5C293 378.186 290.314 375.5 287 375.5Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <g filter="url(#filter0_d_232_1992)">
            <path
                d="M488.5 358C488.5 353.858 491.858 350.5 496 350.5H580C584.142 350.5 587.5 353.858 587.5 358V382C587.5 386.142 584.142 389.5 580 389.5H496C491.858 389.5 488.5 386.142 488.5 382V358Z"
                fill="none"
                stroke="var(--et-colors-text)"
            />
            <text
                fill="var(--et-colors-text)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="14"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="516.5" y="374.3">Adjust</tspan>
            </text>
        </g>
        <g filter="url(#filter1_d_232_1992)">
            <path
                d="M596.5 358C596.5 353.858 599.858 350.5 604 350.5H688C692.142 350.5 695.5 353.858 695.5 358V382C695.5 386.142 692.142 389.5 688 389.5H604C599.858 389.5 596.5 386.142 596.5 382V358Z"
                fill="var(--et-colors-brand)"
                stroke="#101828"
            />
            <text
                fill="var(--et-colors-background)"
                xml:space="preserve"
                style="white-space: pre"
                font-family="Geist"
                font-size="14"
                font-weight="500"
                letter-spacing="0em"
            >
                <tspan x="622" y="374.3">Accept</tspan>
            </text>
        </g>
        <defs>
            <filter
                id="filter0_d_232_1992"
                x="486"
                y="349"
                width="104"
                height="44"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_232_1992"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_232_1992"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_d_232_1992"
                x="594"
                y="349"
                width="104"
                height="44"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_232_1992"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_232_1992"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
</template>
<script setup lang="ts"></script>
